export class Registro {
  public cuenta: string;
  public contrasenia: string;
  public nombre: string;
  public apellido: string;
  public nomPublico: string;
  public correoElectronico: string;
}
